export default "__VITE_ASSET__BPcUApWL__"